import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';

export interface ModalCreateItemConfig {
    textDescription: string;
    inputLabel: string;
    inputPlaceholder?: string;
    initialValue?: string;
    cancelButtonLabel?: string;
    createButtonLabel?: string;
}

@Component({
    standalone: true,
    imports: [ButtonModule, TranslateModule, InputTextModule, ReactiveFormsModule],
    templateUrl: './modal-create-item.component.html',
    styleUrls: ['./modal-create-item.component.scss']
})
export class ModalCreateItemComponent implements OnInit {
    form!: FormGroup;
    name: FormControl = new FormControl('', Validators.required);

    public config: DynamicDialogConfig<ModalCreateItemConfig> = inject(DynamicDialogConfig);
    public ref: DynamicDialogRef = inject(DynamicDialogRef);

    get modalConfig(): ModalCreateItemConfig {
        return this.config.data || ({} as ModalCreateItemConfig);
    }

    get isFormValid(): boolean {
        return this.form.valid;
    }
    ngOnInit(): void {
        this.initForm();
    }

    initForm(): void {
        const initialValue = this.modalConfig.initialValue || '';
        this.name.setValue(initialValue);
        this.form = new FormGroup({
            name: this.name
        });
    }

    onCreate(): void {
        if (this.isFormValid) {
            this.ref.close(this.form.value);
        }
    }

    onCancel(): void {
        this.ref.close();
    }
}
